import { WhiteLabelThemeData } from "app/core/white-label/white-label.type";

export const O2_SIP_TRUNK_WHITELABEL_DATA: WhiteLabelThemeData = {
  productTitle: "O2 Business Teams Telefonie",
  isLoginFooterLogoShown: false,
  userProfileLink: "https://id.teamstelefonie.o2business.de",
  userManagementLink: "https://accounts.teamstelefonie.o2business.de",
  legalLinks: [
    {
      name: "imprint",
      url: "https://www.o2online.de/business/recht/impressum/",
      e2e: "__imprint",
    },
    {
      name: "data_protection",
      url: "https://www.o2business.de/recht/datenschutz/",
      e2e: "__data-protection",
    },
    {
      name: "gtc_sla",
      url: "https://www.o2online.de/business/recht/agb/",
      e2e: "__terms-and-conditions",
    },
  ],
  login: {
    links: [
      {
        name: "Documentation",
        url: {
          default:
            "https://my.teamstelefonie.o2business.de/en/technical-documentation/documentation/manuals",
          de: "https://my.teamstelefonie.o2business.de/de/technischedokumentation/dokumentation/handbuecher",
        },
        e2e: "__documentation",
      },
    ],
    isHiddenReportingPortalUrl: true,
    isShowPortalMenu: true,
    isTwoColumnLayout: true,
    productLogo: "product-logo.svg",
  },
  logo: [
    {
      location: ["info-page"],
      name: "logo--blue",
    },
  ],
  meetingPerUser: "Meet & Share Plus",
  nconnectVoiceProductName: "O2 Business Teams Telefonie",
};
